/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class MapConfigurationsModel {
        public mapConfigurations: Wars.Domain.Model.Gis.MapConfiguration[];
        public gisDatastores:Wars.Domain.Model.Gis.GisDatastore[];
        private systemLevelId: string;

        constructor(private mapConfigurationService: services.MapConfigurationService,
            private systemLevelService: services.SystemLevelService,
            private deleteService: services.DeleteService,
            private processConfigurationId: string,
            private $location:angular.ILocationService) {

            if (processConfigurationId) {
                mapConfigurationService.getMapConfigurations().then(mapConfigs => {
                    this.mapConfigurations = mapConfigs;
                });
            } else {
                systemLevelService.getSystemLevelMapConfigurations().then(systemLevel => {
                    this.mapConfigurations = systemLevel.myMapConfigurations;
                    this.systemLevelId = systemLevel.id;
                });
            }
        }

        public addMapConfiguration() {
            let newMapConfig= this.mapConfigurationService.createMapConfiguration();

            newMapConfig.systemLevel_id = this.systemLevelId;
            newMapConfig.showZoomControl = true;
            newMapConfig.defaultZoom = 6;
            newMapConfig.centerX = 28.0;
            newMapConfig.centerY = -81.9;
            newMapConfig.name = "New Map";

            this.mapConfigurations.push(newMapConfig);

            this.save();
        }

        public editMapConfiguration(map: Wars.Domain.Model.Gis.MapConfiguration) {
            this.$location.path('/MapConfiguration/' + map.id);
        } 

        public save() {
            this.mapConfigurationService.saveAllChanges();
        }

        public deleteMapConfiguration(map: Wars.Domain.Model.Gis.MapConfiguration) {
            this.deleteService.deleteWithModalConfirmIfNecessary("MapConfiguration", map.id, "Map Configuration");
        }

    }
}